"use client";
import { jsx as a } from "react/jsx-runtime";
import { c as l } from "./card-BC9t8iAS.js";
function s({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "table-container",
      className: "relative w-full overflow-x-auto",
      children: /* @__PURE__ */ a(
        "table",
        {
          "data-slot": "table",
          className: l("w-full caption-bottom text-sm", e),
          ...t
        }
      )
    }
  );
}
function d({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "thead",
    {
      "data-slot": "table-header",
      className: l("[&_tr]:border-b", e),
      ...t
    }
  );
}
function n({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "tbody",
    {
      "data-slot": "table-body",
      className: l("[&_tr:last-child]:border-0", e),
      ...t
    }
  );
}
function c({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "tfoot",
    {
      "data-slot": "table-footer",
      className: l(
        "border-t bg-muted/50 font-medium [&>tr]:last:border-b-0",
        e
      ),
      ...t
    }
  );
}
function b({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "tr",
    {
      "data-slot": "table-row",
      className: l(
        "border-b transition-colors hover:bg-muted/50 has-aria-expanded:bg-muted/50 data-[state=selected]:bg-muted",
        e
      ),
      ...t
    }
  );
}
function i({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "th",
    {
      "data-slot": "table-head",
      className: l(
        "h-12 px-3 text-left align-middle text-xs font-medium tracking-wider whitespace-nowrap text-muted-foreground uppercase [&:has([role=checkbox])]:pr-0",
        e
      ),
      ...t
    }
  );
}
function u({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "td",
    {
      "data-slot": "table-cell",
      className: l(
        "p-3 align-middle whitespace-nowrap [&:has([role=checkbox])]:pr-0",
        e
      ),
      ...t
    }
  );
}
function m({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "skeleton",
      className: l("animate-pulse bg-muted", e),
      ...t
    }
  );
}
export {
  m as S,
  s as T,
  d as a,
  n as b,
  c,
  i as d,
  b as e,
  u as f
};
